<script>
import { getTreeType } from "@/api/goods/goodsType.js";

export default {
  name: "type",
  props: {
    // 显示类型ID
    showTypeId: {
      type: String,
      default: 'All',
    },
  },
  data() {
    return {
      t1: [
        // {
        //   name: "",
        //   id: "All",
        // }
      ],
      t2: [],
      t3: [],
      t4: [],
    };
  },
  created() {
    this.getTreeType();
  },
  methods: {
    // 获取类型
    async getTreeType() {
      const res = await getTreeType();
      //调用多语言
      this.setType(res.data.data, this.$t("Category"));
    },
    // 设置类型
    setType(data, firName) {
      // 用于判断显示类型等级，1级，2级，3级，4级..分类
      const firstVal = Object.values(data)[0];
      const num = firstVal.cls_no.length;

      let resDa = [];
      for (let v in data) {
        if (data[v].has_goods_num < 1) {
          continue;
        }
        // 中英文判断
        let toName = "";
        if (this.$i18n.locale === "zh-CN") {
          toName = data[v].cls_cn;
        } else {
          toName = data[v].cls_name;
        }
        let theIN = {
          name: toName,
          id: data[v].cls_no,
          children: data[v].sub,
        };
        resDa.push(theIN);
      }
      switch (num) {
        case 2:
          resDa.unshift({
            name: "All",
            id: "All",
            children: [],
          });
          this.t1 = resDa;
          this.t2 = []
          this.t3 = []
          this.t4 = []
          break;
        case 4:
          this.t2 = resDa;
          this.t3 = []
          this.t4 = []
          break;
        case 6:
          this.t3 = resDa;
          this.t4 = []
          break;
        case 8:
          this.t4 = resDa;
          break;
      }
      resDa.unshift({
        name: firName,
        id: "",
        children: [],
      });
    },
    // 点击类型
    clickType(data, name) {
      this.$emit('update:showTypeId', data.id);
      if (Object.keys(data.children).length > 0) {
        this.setType(data.children, name);
      }
    },
  },
};
</script>

<template>
  <div class="typeBody">
    <div v-if="t1" class="typeShow">
      <ul>
        <li v-for="(item,index) in t1" :key="index">
          <span
            :class="{
              active: item.id == showTypeId,
            }"
            @click="clickType(item, item.name)"
          >{{ item.name }}</span>
        </li>
      </ul>
    </div>

    <div v-if="t2" class="typeShow">
      <ul>
        <li v-for="(item,index) in t2" :key="index">
          <span
            :class="{
              active: item.id == showTypeId,
            }"
            @click="clickType(item, item.name)"
          >{{ item.name }}</span>
        </li>
      </ul>
    </div>

    <div v-if="t3" class="typeShow">
      <ul>
        <li v-for="(item,index) in t3" :key="index">
          <span
            :class="{
              active: item.id == showTypeId,
            }"
            @click="clickType(item, item.name)"
          >{{ item.name }}</span>
        </li>
      </ul>
    </div>

    <div v-if="t4" class="typeShow">
      <ul>
        <li v-for="(item,index) in t4" :key="index">
          <span
            :class="{
              active: item.id == showTypeId,
            }"
            @click="clickType(item, 5,item.name)"
          >{{ item.name }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<style scoped>
.typeBody {
  width: 1390px;
  margin: auto;
  color: #515a6e;
  font-size: 18px;
}

.typeShow {
  display: flex;
  margin-bottom: 5px;
}

.typeShow ul {
  display: flex;
  flex-wrap: wrap;
}

.typeShow ul li {
  margin-right: 20px;
  margin-bottom: 10px;
  cursor: pointer;
  font-size: 18px;
}

.typeShow ul li .active {
  background: #218da0;
  padding: 3px;
  color: white;
}

.typeShow ul li:first-child {
  color: black;
  font-weight: bold;
  cursor: default;
}
</style>